// components/Header.jsx - Top navigation with mode toggle
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth, signOut } from '../auth';

const Header = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentTime, setCurrentTime] = useState(new Date());

  // Determine current mode based on path
  const getCurrentMode = () => {
    const budgetingPaths = ['/transactions', '/debts', '/budget', '/bills'];
    const tradingPaths = ['/', '/orders', '/trades'];

    if (budgetingPaths.some(path => location.pathname.startsWith(path))) {
      return 'budgeting';
    }
    if (tradingPaths.some(path => location.pathname === path)) {
      return 'trading';
    }
    return 'budgeting'; // default
  };

  const [mode, setMode] = useState(getCurrentMode());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    setMode(getCurrentMode());
  }, [location.pathname]);

  const handleModeChange = (newMode) => {
    setMode(newMode);
    if (newMode === 'budgeting') {
      navigate('/transactions');
    } else {
      navigate('/');
    }
  };

  const handleLogout = async () => {
    try {
      await signOut();
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <header className="header">
      <div className="header-content">
        {/* Logo */}
        <div className="header-logo">
          <i className="fas fa-chart-candlestick"></i>
          <span>PennyWise</span>
        </div>

        {/* Mode Toggle */}
        <div className="header-mode-toggle">
          <button
            className={`mode-toggle-btn ${mode === 'budgeting' ? 'active' : ''}`}
            onClick={() => handleModeChange('budgeting')}
          >
            <i className="fas fa-wallet"></i>
            <span>Budgeting</span>
          </button>
          <button
            className={`mode-toggle-btn ${mode === 'trading' ? 'active' : ''}`}
            onClick={() => handleModeChange('trading')}
          >
            <i className="fas fa-chart-line"></i>
            <span>Trading</span>
          </button>
        </div>

        {/* Time/Date and User Info */}
        <div className="header-right">
          <div className="header-datetime">
            <div className="header-time">{formatTime(currentTime)}</div>
            <div className="header-date">{formatDate(currentTime)}</div>
          </div>
          <div className="header-user">
            <div className="header-user-avatar">
              <i className="fas fa-user"></i>
            </div>
            <div className="header-user-info">
              <div className="header-user-name">
                {user?.username || 'User'}
              </div>
            </div>
          </div>
          <button className="header-logout-btn" onClick={handleLogout} title="Logout">
            <i className="fas fa-sign-out-alt"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;